<template>
    
    <rkm-modal
        ref="Modal"
        :title="'LAUDO DE SOLICITAÇÃO, AVALIAÇÃO E AUTORIZAÇÃO DE MEDICAMENTO(S)'"
        extraLarge
        :buttons="['cancel', 'save']"
        @save="handleSave"
    >
        <template #footer>

            <rkm-button
                color="info"
                 @click="handlePrint"         
            >
                Imprimir
            </rkm-button>

        </template>

        <template>
            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-input
                        :label="'CNES'"
                        v-model="data.additionals.unidade.cnes"
                        disabled
                    >
                    
                    </rkm-form-input>

                </rkm-col>
                    <rkm-col cols="10">
                        <rkm-form-input
                            :label="'Unidade'"
                            v-model="data.additionals.unidade.nome"
                            disabled

                        > 
                        </rkm-form-input>

                    </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="10">
                    <rkm-form-input
                        :label="'Nome completo do paciente'"
                        v-model="data.additionals.paciente.nome"
                        disabled
                    >                
                    </rkm-form-input>

                </rkm-col>
                    <rkm-col cols="2">
                        <rkm-form-input
                            :validations="validations.peso"
                            append="kg"
                            @change.native="handleChangeDecimals($event, 'peso')"
                            label="Peso"
                            v-mask="masks.peso"
                            placeholder="000.000"
                            v-model="model.peso"
                        />

                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="10">
                    <rkm-form-input
                        :label="'Nome da mãe do paciente'"
                        v-model="data.additionals.paciente.nomeMae"
                        disabled
                    >        
                    </rkm-form-input>

                </rkm-col>
                    <rkm-col cols="2">
                    <rkm-form-input
                        :validations="validations.altura"
                        append="cm"
                        @change.native="handleChangeDecimals($event, 'altura')"
                        label="Altura"
                        placeholder="000.0"
                        v-mask="masks.altura"
                        v-model="model.altura"
                    />
                    
                </rkm-col>
            </rkm-row>

            <BoxMedicamentos
                :data="data"
            />

           <rkm-area title="Anamnese">
                <rkm-form-textarea
                    name="Anamnese"
                    :maxlength="120"
                    rows="1"
                    max-rows="1"
                    :validations="validations.anamnese"
                    v-model="model.anamnese"
                />
           </rkm-area>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-select
                        :options="cidOptions"
                        label="CID 10"
                        v-model="cidSelecionado"
                        text-field="codigoNome"
                        value-field="id"
                        disabled
                    />

                </rkm-col>
                    <rkm-col cols="9">
                        <rkm-form-input
                            :label="'Diagnóstico'"
                            v-model="model.diagnostico"
                            :validations="validations.diagnostico"
                            :maxlength="90"
                        > 
                    </rkm-form-input>
                        <div style="font-size: 13px; color: gray; margin-top: 4px;">
                                Caracteres restantes:
                            {{ 90 - (model.diagnostico ? model.diagnostico.length : 0) }}
                        </div>
                        

                </rkm-col>
            </rkm-row>

           <BoxTratamentoPrevio
                :model="model"
           />          
        </template>

    </rkm-modal>
</template>


<script>
import BoxMedicamentos from './components/medicamentos/Form.vue'
import BoxTratamentoPrevio from './components/tratamento-previo/Form.vue'

import { mapActions} from 'vuex'
export default{
    components:{BoxTratamentoPrevio, BoxMedicamentos},
    data() {
        return {
            submitted: false,

            cid: this.data.cidSugestao,

            masks: {
                altura: '###.#',
                peso: '###.###',
            },
            model: {
                tratamentoPrevio: {
                    status: false,
                    relatar: null
                },
                diagnostico: null,
                anamnese: null,
                paciente: null,
                cid: null,
                medicamentos: null,
                peso: null,
                altura: null,
                unidade: {
                    nome: null,
                    cnes: null
                }
            }
        }
    },
    methods:{
        open(){
            this.model.anamnese = this.data.model.prescricaoMedicamentoAnamnese
            this.model.diagnostico = this.data.model.prescricaoMedicamentoDiagnostico
            this.model.tratamentoPrevio.status = Boolean(
                Number(this.data.model.prescricaoMedicamentoTratamentoPrevio.status)
            )
            this.model.tratamentoPrevio.relatar = this.data.model.prescricaoMedicamentoTratamentoPrevio.relatar
            this.$refs.Modal.show()
            this.model.peso = this.data.objetivoModel.antropometria.peso
            this.model.altura = this.data.objetivoModel.antropometria.altura

        

        },
        ...mapActions([
            'setLoading',
            'unsetLoading',
        ]),

        handleSave(){
            const camposInvalidos = this.showRequiredField()

                if(camposInvalidos.length){
                    const mensagem = camposInvalidos.length === 1
                        ? `Preencha o campo obrigatório: ${camposInvalidos.join(', ')}`
                        : `Por favor, preencha os campos obrigatórios: ${camposInvalidos.join(', ')}.`

                        this.showAlert(mensagem, 'Atenção'); 

                        return;
                } 
            this.data.model.prescricaoMedicamentoAnamnese = this.model.anamnese
            this.data.model.prescricaoMedicamentoDiagnostico = this.model.diagnostico
            this.data.model.prescricaoMedicamentoTratamentoPrevio.status = this.model.tratamentoPrevio.status
            this.data.model.prescricaoMedicamentoTratamentoPrevio.relatar = this.model.tratamentoPrevio.relatar 
            this.data.objetivoModel.antropometria.peso = this.model.peso
            this.data.objetivoModel.antropometria.altura = this.model.altura

            this.$refs.Modal.hide()

     
        },
        handleChangeDecimals(event, field) {
            const decimals = (this.masks[field].split('.')[1] || '').length;
            let value = Number(event.target.value).toFixed(decimals);
            const parts = value.split('.');
            const width = this.masks[field].split('.')[0].length;
            parts[0] = ('0'.repeat(width + 1) + parts[0]).slice(-width);
            this.model[field] = parts.join('.'); 
        },

        handlePrint() {
                const camposInvalidos = this.showRequiredField()

                if(camposInvalidos.length){

                    const mensagem = camposInvalidos.length === 1
                        ? `Preencha o campo obrigatório: ${camposInvalidos.join(', ')}`
                        : `Por favor, preencha os campos obrigatórios: ${camposInvalidos.join(', ')}.`

                        this.showAlert(mensagem, 'Atenção'); 

                        return;
                }  

                this.$emit('print', this.model)
        },

        showRequiredField(){
            let campos = []

            if(!this.model.diagnostico){
                campos.push('Diagnostico')
            }

            if(!this.model.anamnese){
                campos.push('Anamnese')
            }

            if(this.model.tratamentoPrevio.status == true && !this.model.tratamentoPrevio.relatar){
                campos.push('Relatar')
            }

            return campos;
        }

    },

    computed:{
        cidOptions(){
            return (this.data.cidSugestao|| []).map(item => ({
                ...item,
                codigoNome: item.codigoNome,
                id: item.id
            }))
        },
        validations() {
            return {
                anamnese: { 
                    required: true,
                    max: 120
                },
                diagnostico: {
                    required: true,
                    max: 90
                },
                peso: {
                    required: !this.data.altura,
                    min_value: 0.5,
                    max_value: 500,
                },
                altura: {
                    required: !this.data.peso,
                    min_value: 20,
                    max_value: 250,
                },
            }
        },
        
        cidSelecionado: {
            get() {
                return this.data.cidSugestao?.[0]?.id || null
            },

            set(value) {
                const cid = this.cidOptions.find(item => item.id === value)

                this.this.data.cidSugestao = cid ? [cid] : []
            }
        },
    },
    props: {
        data: {type: Object, required: true},
    },

}

</script>